export enum ContactStatusEnum {
	Active = 1,
	Passive = 2,
	Inactive = 3,
}
